import React from "react";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Changelog from "@/pages/Changelog";
import CheckoutReturn from "@/pages/CheckoutReturn";
import UiShots from "@/pages/UiShots";
import SmoothScroll from "@/components/SmoothScroll";
import { StoreProvider } from "@/context/StoreContext";
import { BRAND } from "@/lib/brand";
import "@/App.css";

const Outcome = ({ title, body }) => (
  <main className="grid min-h-screen place-items-center bg-[#08080a] px-6">
    <div className="max-w-lg text-center">
      <img src={BRAND.lockup} alt="Orvyn FiveM Scripts" className="mx-auto h-12 w-auto" />
      <h1 className="mt-10 font-display text-3xl font-extrabold uppercase tracking-tight text-white sm:text-4xl">
        {title}
      </h1>
      <p className="mt-5 text-sm leading-relaxed text-white/45">{body}</p>
      <div className="mt-10 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="bg-white px-7 py-3.5 font-mono text-[11px] uppercase tracking-[0.2em] text-black"
        >
          Back to site
        </Link>
        <a
          href={BRAND.discord}
          target="_blank"
          rel="noopener noreferrer"
          className="border border-white/18 px-7 py-3.5 font-mono text-[11px] uppercase tracking-[0.2em] text-white/70 transition-colors hover:border-white/45 hover:text-white"
        >
          Discord
        </a>
      </div>
    </div>
  </main>
);

function App() {
  return (
    <StoreProvider>
      <SmoothScroll>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/changelog" element={<Changelog />} />
            <Route path="/checkout/:ident" element={<CheckoutReturn />} />
            <Route path="/ui-shots" element={<UiShots />} />
            <Route
              path="/success"
              element={
                <Outcome
                  title="Purchase complete"
                  body="Your download and licence have been issued to your Tebex account. Join the Discord if you need a hand with install."
                />
              }
            />
            <Route
              path="/cancelled"
              element={
                <Outcome
                  title="Checkout cancelled"
                  body="No charge was made. Head back whenever you're ready, or ask us anything in the Discord first."
                />
              }
            />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="bottom-right" />
      </SmoothScroll>
    </StoreProvider>
  );
}

export default App;
